module.exports = __webpack_public_path__ + "img/ginger-milk-tea.f966e82f.jpg";